<template>
  <div>
    <v-btn small color="yellow darken-1" @click="dialog = true" icon
      ><v-icon>mdi-pencil</v-icon></v-btn
    >
    <v-dialog v-model="dialog" width="450" class="ma-auto" persistent>
      <v-card>
        <v-card-title>Edit Department</v-card-title>
        <v-card-text>
          <v-text-field
            label="Department Name"
            v-model="item.department_name"
          ></v-text-field>
          <v-text-field
            label="Signatory"
            v-model="item.signatory"
          ></v-text-field>
          <v-text-field
            label="Signatory Position"
            v-model="item.signatory_position"
          ></v-text-field>
        </v-card-text>

        <v-card-actions
          ><v-btn @click="edit_dep">Edit</v-btn>
          <v-btn @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["item"],
  data() {
    return {
      show_alert: false,
      alert_message: "",
      alert_type: "",
      dialog: false,
    };
  },
  methods: {
    ...mapActions({
      edit_department: "department/edit_department",
    }),

    async edit_dep() {
      await this.edit_department(this.item);
      alert("Successfully edited a department");
    },
  },
};
</script>

<style lang="scss" scoped></style>
